import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcDarkPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12.0003,
		cy: 7.71422,
		r: 3.42857,
		fill: "#CED2DA"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.14307 15C5.14307 13.3431 6.48621 12 8.14307 12H15.8574C17.5142 12 18.8574 13.3431 18.8574 15V18.7143C18.8574 19.2666 18.4096 19.7143 17.8574 19.7143H6.14307C5.59078 19.7143 5.14307 19.2666 5.14307 18.7143V15Z",
		fill: "#A9AFBB"
	})]
});
export default SvgIcDarkPerson;
